<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
	  <IndexHeader></IndexHeader>
        <div class="widget-heading d-block">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-flex align-items-center">
              <h4 class="me-3 my-0">Szablony artykułów</h4>

              <Link class="btn btn-outline-primary btn-sm" :href="route('articles.index')">Lista artykułów
              </Link>

            </div>
          </div>
        </div>

        <div class="widget-content">
          <div>
            <ejs-grid ref="articlesTemplateGrid" id="articlesTemplateGrid" height="500px"
                      :dataSource="dataManager"
                      :allowTextWrap='false'
                      :allowExcelExport='true'
                      :allowPaging="true"
                      :allowSorting='true'
                      :allowFiltering='true'
                      :allowReordering='false'
                      :allowResizing='true'
                      :showColumnChooser='true'
                      :allowSelection='true'
                      :enablePersistence='true'
                      :actionBegin="actionBegin"
                      :actionComplete="actionComplete"
                      :pageSettings="pageSettings"
                      :editSettings="editSettings"
                      :filterSettings="filterOptions"
                      :toolbar="toolbar"
                      :rowDataBound="onRowDataBound"
                      :rowSelected="rowSelected"
                      :keyPressed="onKeyDown"
                      :beforeBatchAdd="beforeBatchAdd"
                      :cellEdit="onCellEdit"
                      :beforeBatchSave="beforeBatchSave"
                      :toolbarClick="toolbarClick"
                      :cellSave="cellSave">
              <e-columns>
                <e-column field="id" headerText="ID" width="92" :isPrimaryKey="true" :allowEditing="false"
                          type="number"/>
                <e-column field="catalog_number" headerText="Nr katalogowy" width="150" type="string"
                          :edit="catalogEditor" :filter="filterDefault"/>
                <e-column field="model" headerText="Model" width="150" :filter="filterDefault" type="string"/>
                <e-column field="article_unit.id" headerText="J.m." width="150" editType="dropdownedit"
                          :dataSource="units" foreignKeyValue='name' foreignKeyField='id'
                          :filter='filterUnits'/>
                <e-column field="description" headerText="Nazwa/Opis" :defaultValue="null" width="200"
                          :filter="filterDefault"/>
                <e-column field="details" headerText="Szczegóły" type="string" :defaultValue="null" width="200"
                          :filter="filterDefault"/>
                <e-column field="link" headerText="Link" :defaultValue="null" :filter="filterDefault" type="string"
                          :template="'linkTemplate'"/>
                <e-column field="created_at" headerText="Utworzono" width="150" type="date"
                          format="dd.MM.yyyy HH:mm:ss" :allowEditing="false"/>
                <e-column field="created_by.id" headerText="Utworzył" width="150" :allowEditing="false"
                          :dataSource="users" foreignKeyValue='name' foreignKeyField='id'
                          :defaultValue="$page.props.user.id" :filter="filterCreatedBy"/>
                <e-column field="producer.id" headerText="Producent" width="150" editType="dropdownedit"
                          :dataSource="producers" foreignKeyValue='short_name' foreignKeyField='id'
                          :filter='filterProducers'/>
                <e-column field="customer_category.id" headerText="Kategoria" width="250" editType="dropdownedit"
                          :dataSource="categories" foreignKeyValue='name' foreignKeyField='id'
                          :filter='filterCategories'/>
              </e-columns>

              <template v-slot:linkTemplate="{data}">
                <a class="link link-primary" target="_blank" rel="noopener noreferrer" :href=data.link>{{
                    data.link
                  }}</a>
              </template>

            </ejs-grid>
          </div>

        </div>
      </div>
    </div>

  </AppLayout>
</template>

<script>
import AppLayout from "../../../../Layouts/App.vue";
import {useForm, usePage} from "@inertiajs/vue3";
import {AutoComplete, MultiSelect} from '@syncfusion/ej2-vue-dropdowns';
import {TextBox} from '@syncfusion/ej2-inputs';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter,
  ForeignKey,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar,
  VirtualScroll
} from '@syncfusion/ej2-vue-grids';
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import {createElement} from "@syncfusion/ej2-base";
import {DataManager, WebMethodAdaptor, Predicate, Query} from '@syncfusion/ej2-data';
import {DropDownList} from "@syncfusion/ej2-dropdowns";
import IndexHeader from "@/Pages/Warehouses/Articles/IndexHeader.vue";

import moment from "moment";

const {hasRole, hasPermission} = usePermission();

let dropInstanceFilterUnits;
export default {
  computed: {
    id() {
      return id
    },

    catalogNumbers() {
      return this.articles_template.map(article => article.catalog_number).filter((value, index, self) => self.indexOf(value) === index);
    },
  },

  components: {
    AppLayout,
    hasRole,
    hasPermission,
    MultiSelect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
	IndexHeader,
    'e-column': ColumnDirective
  },

  provide: {
    grid: [Page, ContextMenu, Edit, Toolbar, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, VirtualScroll]
  },

  props: {
    units: Object,
    categories: Object,
    locations: Object,
    warehouses: Object,
    producers: Object,
    suppliers: Object,
    users: Object,
    exchangeRate: Object
  },

  mounted() {
    this.getNBPExchangeRate();
    // this.fetchArticles(1, this.pageSettings.pageSize);
  },

  data() {
    let ddElem;
    let multiSelectObj;

    const createSuppliersFn = () => {
      ddElem = document.createElement('input');
      return ddElem;
    };

    const readSuppliersFn = () => {
      return multiSelectObj.value.join(","); // Zwróć wartości jako string
    };

    const destroySuppliersFn = () => {
      multiSelectObj.destroy(); // Usunięcie instancji MultiSelect
    };

    const writeSuppliersFn = (args) => {
      const selectedValues = args.rowData.suppliers_short_names ? args.rowData.suppliers_short_names.split(",") : [];

      // Inicjalizacja MultiSelect
      multiSelectObj = new MultiSelect({
        value: selectedValues,
        dataSource: this.suppliers,
        fields: {text: "short_name", value: "short_name"},
        placeholder: 'Wybierz dostawców',
        mode: 'Box',
        allowFiltering: true,
        popupHeight: '200px',
        closePopupOnSelect: false,
      });

      multiSelectObj.appendTo(ddElem);
    };

    return {
      hasPermission,
      photoForm: useForm({
        article_id: null,
        default: null,
        photo_path: null,
      }),
      articles: [],
      loadingRate: false,
      eurRate: {rate: 0, date: null},
      currentEditingRowData: {},
      dataManager: new DataManager({
        url: route('articles.template.get'),
        adaptor: new WebMethodAdaptor(),
        batchUrl: route('articles.template.saveChanges'),
        crossDomain: true,
        headers: [
          {'X-CSRF-TOKEN': usePage().props.csrf_token}
        ]
      }),
      pageSettings: {pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200, 500, 1000]},
      showHistoryModal: false,
      showFilesModal: false,
      selectedFile: null,
      isAddingNew: false,
      selectedArticle: null,
      taskGridKey: 0,
      // contextMenuItems: this.getContextMenu(),
      filterOptions: {type: "Menu"},
      toolbar: this.getToolbar(),
      editSettings: this.getEditSettings(),
      selectionOptions: {type: 'Multiple', cellSelectionMode: 'Box', mode: 'Cell'},
      suppliersParams: {
        create: createSuppliersFn,
        destroy: destroySuppliersFn,
        read: readSuppliersFn,
        write: writeSuppliersFn
      },
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      filterUnits: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.units,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj jednostki',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
      filterCreatedBy: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.users,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj kto stworzył',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterCategories: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.categories,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj kategorii',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
      filterLocations: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.locations,
              fields: {text: 'short_name', value: 'id'},
              placeholder: 'Szukaj magazynu',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
      filterProducers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.producers,
              fields: {text: 'short_name', value: 'id'},
              placeholder: 'Szukaj Producenta',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
      filterSuppliers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.suppliers,
              fields: {text: 'short_name', value: 'short_name'},
              placeholder: 'Szukaj dostawców',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
    }
  },

  methods: {

    async getNBPExchangeRate() {

      // jeśli kurs był już zapisany i pobrany to nic nie rób
      if (this.exchangeRate) {
        this.eurRate.rate = this.exchangeRate.rate;
        this.eurRate.date = this.exchangeRate.date;
        return;
      }

      this.loadingRate = true;
      try {
        const response = await axios.get(route('api.euro-rate'));
        if (response.data.rate && response.data.date) {
          this.eurRate = {
            rate: response.data.rate, // Pobieranie kursu EUR
            date: response.data.date  // Data kursu
          }
        } else {
          console.error('Nie udało się pobrać kursu EUR', response);
          this.eurRate = {rate: 0, date: null};
        }
      } catch (error) {
        console.error('Błąd podczas pobierania kursu EUR:', error);
        this.eurRate = {rate: 0, date: null};
      }
      this.$nextTick(() => {
        this.loadingRate = false;
      })
    },

    getEditSettings() {
      return {
        allowEditing: hasPermission('canEditArticlesTemplate'),
        allowAdding: hasPermission('canEditArticlesTemplate'),
        allowDeleting: hasPermission('canEditArticlesTemplate'),
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch',
        newRowPosition: 'Top',
      };
    },

    getToolbar() {
      const tools = [];

      if (hasPermission('canEditArticlesTemplate')) {
        tools.push("Add");
        tools.push({text: 'Usuń', prefixIcon: 'e-delete', id: 'delete_btn'});
        tools.push("Update");
        tools.push("Cancel");
      }

      tools.push(
          {text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters'},
          {text: "Search", prefixIcon: 'e-search', id: "search", align: 'center'},
          {text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
          {text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right'},
          "ColumnChooser"
      );

      return tools;
    },

    userCanModify() {
      let rights = 0;
      if (this.usersCanChange) {
        rights = this.usersCanChange.find(email => email === this.$page.props.user.email);
      }

      return !(rights === undefined || rights <= 0);
    },

    beforeBatchAdd(args) {
      // blokada na tworzenie jednocześnie kilku wpisów
      if (this.isAddingNew) {
        args.cancel = true;
      } else {
        this.isAddingNew = true;
      }
    },

    onCellEdit(args) {
      if (args.rowData.deleted_at) {
        // Anuluj edycję, jeśli rekord został usunięty
        args.cancel = true;
        // wyświetl powiadomienie
        Toast.fire({
          position: 'top-end',
          toast: true,
          icon: 'warning',
          title: 'Edycja',
          html: 'Nie można edytować usuniętych rekordów.',
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
          showCloseButton: true
        });
        console.log('Nie można edytować usuniętych rekordów.');
      }
    },

    toolbarClick(args) {
      // cancellowanie isAddingNew, tzn. jak się kliknie update lub cancel to powinno dać się znowu dodać nowy wiersz
      if (args.item.id === 'articlesTemplateGrid_update' || args.item.id === 'articlesTemplateGrid_cancel') {
        this.isAddingNew = false;
      }

      // Obsługa przycisku delete
      if (args.item.id === 'delete_btn') {
        const selectedRecords = this.$refs.articlesTemplateGrid.ej2Instances.getSelectedRecords();

        if (selectedRecords.length > 0) {
          // Usuwanie zaznaczonego rekordu
          this.$refs.articlesTemplateGrid.ej2Instances.deleteRecord('id', selectedRecords[0]);
        }
      }

      // Akcja przy kliknięciu resetowania filtrów
      if (args.item.id === 'reset_filters') {
        this.$refs.articlesTemplateGrid.clearFiltering();
      }

      if (args.item.id === 'restore') {
        let grid = this.$refs.articlesTemplateGrid;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
        location.reload();
      }

      if (args.item.id === 'excelexport') {
        this.$refs.articlesTemplateGrid.excelExport({
          fileName: `Lista artykułów.xlsx`
        });
      }
    },

    async beforeBatchSave(args) {
      this.$makeClean();
      try {
        const mapFields = (record) => ({
          id: record.id,
          catalog_number: record.catalog_number,
          model: record.model,
          unit_id: record.article_unit?.id,
          description: record.description,
          details: record.details,
          link: record.link,
          created_by: record.created_by?.id,
          category_id: record.customer_category?.id,
          vat: record.vat,
          price_netto_zl: record.price_netto_zl,
          price_brutto_zl: record.price_brutto_zl,
          price_netto_eur: record.price_netto_eur,
          price_brutto_eur: record.price_brutto_eur,
          photos: record.photos,
          location_id: record.location?.id,
          warehouse_id: record.warehouse?.id,
          producer_id: record.producer?.id,
          stock_quantity: record.stock_quantity,
          income: record.income,
          outflow: record.outflow,
          value_net: record.value_net,
          value_gross: record.value_gross,
          suppliers: record.suppliers_short_names,
        });

        // Pobierz zmodyfikowane dane (nowe, zmienione, usunięte)
        const updatedRecords = args.batchChanges.changedRecords.map(mapFields);
        const addedRecords = args.batchChanges.addedRecords.map(mapFields);
        const deletedRecords = args.batchChanges.deletedRecords.map(record => ({id: record.id}));

        // Wysyłanie danych przy użyciu Inertia.js z `onSuccess`
        this.$inertia.post(route('articles.template.saveChanges'),
            {
              updated: updatedRecords,
              added: addedRecords,
              deleted: deletedRecords,
            },
            {
              only: ['errors', 'flash', 'newRecords', 'updatedRecords', 'deletedRecords', 'articles'],
              preserveState: true,
              onSuccess: (page) => {
                const newRecords = page.props.newRecords || [];
                const updatedRecordsFromServer = page.props.updatedRecords || [];

                // Zaktualizuj Syncfusion Grid:
                newRecords.forEach((newRecord) => {
                  const index = this.$refs.articlesTemplateGrid.ej2Instances.getIndexByRowData({id: newRecord.temp_id});
                  if (index !== -1) {
                    this.$refs.articlesTemplateGrid.ej2Instances.updateRow(index, newRecord);
                  } else {
                    this.$refs.articlesTemplateGrid.ej2Instances.addRecord(newRecord);
                  }
                });

                updatedRecordsFromServer.forEach((updatedRecord) => {
                  const index = this.$refs.articlesTemplateGrid.ej2Instances.getIndexByRowData({id: updatedRecord.id});
                  if (index !== -1) {
                    this.$refs.articlesTemplateGrid.ej2Instances.updateRow(index, updatedRecord);
                  }
                });

                this.successMsg('Dane zostały zapisane!');
                this.$makeClean();
                this.$refs.articlesTemplateGrid.ej2Instances.refresh();
              },

              onError: (errors) => {
                console.error('Błąd podczas zapisywania danych:', errors);
                this.errorMsg('Błąd podczas zapisywania danych.');
              },
            }
        );
      } catch (error) {
        console.log(error);
        this.$makeDirty();
        console.error('Błąd podczas zapisywania danych:', error);
        this.errorMsg('Błąd podczas zapisywania danych.');
      }
    },


    async cellSave(args) {
      if (args.previousValue !== args.value) {
        this.$makeDirty();
      }

      /**
       * Przy wyjściu z edycji Nr katalogowego i zmianie jego wartości sprawdź, czy jest już taki w bazie,
       * jeśli tak, to wyświetl komunikat.
       */
      if (args.columnName === 'catalog_number' && args.previousValue !== args.value) {
        let sameArticles = await this.checkCatalogNumber(args.value);
        if (sameArticles.length > 0) {
          this.articleAlreadyExist(sameArticles)
        }
      }

      /**
       * podczas edycji pricingów, vat czy netto/brutto zmień wszystkie inne
       */
      const {columnName, value} = args;
      // Pobierz najnowsze dane wiersza z Grid zamiast z args.rowData
      const currentRecords = this.$refs.articlesTemplateGrid.ej2Instances.getCurrentViewRecords();
      const rowIndex = currentRecords.findIndex(record => record.id === args.rowData.id);
      if (rowIndex === -1) return; // Jeśli indeks nie istnieje, przerwij działanie

      // Ustaw `currentEditingRowData` na najnowszy stan wiersza z Grid
      this.currentEditingRowData = {...currentRecords[rowIndex]};
      this.currentEditingRowData[columnName] = parseFloat(value) || value;

      // Wartości netto/brutto, VAT i ilość
      // const priceNettoZl = parseFloat(this.currentEditingRowData.price_netto_zl || 0);
      // const priceNettoEur = parseFloat(this.currentEditingRowData.price_netto_eur || 0);
      // const vat = parseFloat(this.currentEditingRowData.vat || 0);
      // const quantity = parseFloat(this.currentEditingRowData.stock_quantity || 0);

      // // Wywołaj odpowiednie przeliczenia w zależności od zmodyfikowanej kolumny
      // if (columnName === 'price_netto_zl') {
      //   this.updateEuroFromZl(priceNettoZl);
      // } else if (columnName === 'price_netto_eur') {
      //   this.updateZlFromEuro(priceNettoEur);
      // } else if (columnName === 'vat') {
      //   this.updateBrutto(priceNettoZl, vat);
      // } else if (columnName === 'price_brutto_zl') {
      //   this.updateNettoFromBrutto(value, vat);
      // }
      //
      // // Po każdej zmianie przelicz wartości całkowite
      // this.calculateTotal(priceNettoZl, priceNettoEur, vat, quantity);
    },

    // updateEuroFromZl(priceNettoZl) {
    //   if (this.eurRate.rate) {
    //     const priceNettoEur = (priceNettoZl / this.eurRate.rate).toFixed(2);
    //     this.currentEditingRowData.price_netto_eur = priceNettoEur;
    //     this.updateCell('price_netto_eur', priceNettoEur);
    //     this.updateBrutto(priceNettoZl, this.currentEditingRowData.vat);
    //   }
    // },

    // updateZlFromEuro(priceNettoEur) {
    //   if (this.eurRate.rate) {
    //     const priceNettoZl = (priceNettoEur * this.eurRate.rate).toFixed(2);
    //     this.currentEditingRowData.price_netto_zl = priceNettoZl;
    //     this.updateCell('price_netto_zl', priceNettoZl);
    //     this.updateBrutto(priceNettoZl, this.currentEditingRowData.vat);
    //   }
    // },

    // updateBrutto(priceNettoZl, vat) {
    //   if (!isNaN(vat)) {
    //     const priceBruttoZl = (priceNettoZl * (1 + vat / 100)).toFixed(2);
    //     this.currentEditingRowData.price_brutto_zl = priceBruttoZl;
    //     this.updateCell('price_brutto_zl', priceBruttoZl);
    //
    //     if (this.eurRate.rate) {
    //       const priceNettoEur = (priceNettoZl / this.eurRate.rate);
    //       const priceBruttoEur = (priceNettoEur * (1 + vat / 100)).toFixed(2);
    //       this.currentEditingRowData.price_brutto_eur = priceBruttoEur;
    //       this.updateCell('price_brutto_eur', priceBruttoEur);
    //     }
    //   }
    // },

    // updateNettoFromBrutto(priceBruttoZl, vat) {
    //   if (vat > 0) {
    //     const priceNettoZl = (priceBruttoZl / (1 + vat / 100)).toFixed(2);
    //     this.currentEditingRowData.price_netto_zl = priceNettoZl;
    //     this.updateCell('price_netto_zl', priceNettoZl);
    //     this.updateEuroFromZl(priceNettoZl);
    //   }
    // },

    // calculateTotal(priceNettoZl, priceNettoEur, vat, quantity) {
    //   const valueNet = (priceNettoZl * quantity).toFixed(2);
    //   const valueGross = (priceNettoZl * quantity * (1 + vat / 100)).toFixed(2);
    //
    //   this.currentEditingRowData.value_net = valueNet;
    //   this.currentEditingRowData.value_gross = valueGross;
    //
    //   // zezwól na edycję tych kolumn
    //   this.$refs.articlesTemplateGrid.ej2Instances.getColumnByField('value_net').allowEditing = true;
    //   this.$refs.articlesTemplateGrid.ej2Instances.getColumnByField('value_gross').allowEditing = true;
    //
    //   // aktualizuj
    //   this.updateCell('value_net', valueNet);
    //   this.updateCell('value_gross', valueGross);
    // },

    // Funkcja pomocnicza do aktualizacji komórki w siatce
    updateCell(columnName, value) {
      const currentRecords = this.$refs.articlesTemplateGrid.ej2Instances.getCurrentViewRecords();
      const rowIndex = currentRecords.findIndex(record => record.id === this.currentEditingRowData.id);
      this.$refs.articlesTemplateGrid.ej2Instances.updateCell(rowIndex, columnName, value);

      // zablokuj możliwość edycji po aktualizacji tych kolumn
      // if (columnName === 'value_net' || columnName === 'value_gross') {
      //   this.$refs.articlesTemplateGrid.ej2Instances.getColumnByField(columnName).allowEditing = false;
      // }
    },


    async checkCatalogNumber(catalogNumber) {
      if (catalogNumber) {
        try {
          const response = await axios.post(route('article.check-catalog-number-if-exists'), {
            catalog_number: catalogNumber
          });
          return response.data;
        } catch (error) {
          console.error('Błąd podczas sprawdzania numeru katalogowego:', error);
          return [];
        }
      }
      return [];
    },

    async articleAlreadyExist(theSameArticles) {
      let html = '<table class="table table-bordered"><thead><tr><th>Nr Kat.</th><th>Model</th><th>Opis</th></tr></thead><tbody>';
      theSameArticles.forEach(article => {
        html += '<tr>';
        html += `<td>${article.catalog_number}`;
        html += `<td>${article.model || ''}</td>`;
        html += `<td>${article.description || ''}</td>`;
        html += '</tr>';
      });

      html += '</tbody></table>';

      const {value: selectedOption} = await Toast.fire({
        position: 'center',
        toast: false,
        icon: 'warning',
        title: 'Istnieje już taki nr katalogowy',
        html: html,
        timer: false,
        showCancelButton: false,
        showCloseButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
      });
    },

    onRowDataBound(args) {
      if (args.data.deleted_at) {  // Sprawdź, czy rekord został "miękko" usunięty
        args.row.classList.add('deleted-row');
      }
    },

    rowSelected(args) {
      this.selectedArticle = args.data;
    },

    dateFormatter(field, data) {
      const date = data.created_at ? data.created_at : null;
      if (date) {
        try {
          return moment(date).format('DD.MM.YYYY HH:mm:ss');
        } catch (error) {
          return data
        }
      }

      return '';
    },

    onKeyDown: function (args) {
      let keyCode = args.which || args.keyCode;
      let isCtrlKey = (args.ctrlKey || args.metaKey) ? true : ((keyCode === 17));

      // code 83 to 'S'
      if (isCtrlKey && keyCode === 83) {
        args.preventDefault();

        if (this.userCanModify) {
          // zapisz
          let toolbar = document.getElementsByClassName('e-toolbar-left')[0];
          let buttons = toolbar.querySelectorAll('.e-toolbar-item');
          let updateButton = buttons[2].querySelector('button');
          if (updateButton) {
            updateButton.click();
          }
        }
      }
    },

    actionBegin(args) {
      //
      // WYSZUKIWARKA- wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === 'searching') {
        const keys = args.searchString.split(',');
        let flag = true;
        let predicate;

        if (this.$refs.articlesTemplateGrid.ej2Instances.searchSettings.key !== '') {
          this.values = args.searchString;
          keys.forEach((key) => {
            this.$refs.articlesTemplateGrid.ej2Instances.getColumns().forEach((col) => {
              if (flag) {
                predicate = new Predicate(col.field, 'contains', key, true);
                flag = false;
              } else {
                let predic = new Predicate(col.field, 'contains', key, true);
                predicate = predicate.or(predic);
              }
            });
          });

          this.$refs.articlesTemplateGrid.ej2Instances.query = new Query().where(predicate);
          this.$refs.articlesTemplateGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.articlesTemplateGrid.ej2Instances.refresh();
        } else {
          this.$refs.articlesTemplateGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.articlesTemplateGrid.ej2Instances.refresh();
        }
      }
    },

    actionComplete(args) {
      //
      // WYSZUKIWARKA - wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === "refresh" && this.valueAssign) {
        document.getElementById(
            this.$refs.articlesTemplateGrid.ej2Instances.element.id + "_searchbar"
        ).value = this.values;
        this.valueAssign = false;
      } else if (
          document.getElementById(
              this.$refs.articlesTemplateGrid.ej2Instances.element.id + "_searchbar"
          ).value === "" &&
          args.requestType === "refresh" &&
          this.removeQuery
      ) {
        this.$refs.articlesTemplateGrid.ej2Instances.query = new Query();
        this.removeQuery = false;
        this.$refs.articlesTemplateGrid.ej2Instances.refresh();
      }
    },

    successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    isAdmin() {
      return hasRole('ADMIN');
    },


    catalogEditor() {
      return {
        create: () => {
          const elem = document.createElement('input');
          return elem;
        },
        read: () => {
          return this.autoCompleteObj.value;
        },
        destroy: () => {
          if (this.autoCompleteObj) {
            this.autoCompleteObj.destroy();
          }
        },
        write: (args) => {
          this.autoCompleteObj = new AutoComplete({
            dataSource: this.catalogNumbers,
            placeholder: 'Wpisz lub wybierz istniejący numer katalogowy',
            allowCustom: true, // Pozwala użytkownikowi wpisać nową wartość
            value: args.rowData ? args.rowData.catalog_number : '' // Ustawienie aktualnej wartości
          });
          this.autoCompleteObj.appendTo(args.element);
        }
      };
    },

    // getContextMenu() {
    //   return [
    //     {text: 'Wprowadź artykuł do magazynu', target: '.e-content', id: 'add_article_to_warehouse'},
    //   ]
    // },
    //
    // clickContextMenuHandler(args) {
    //   if (args.item.id === 'add_article_to_warehouse') {
    //     this.selectedArticle = args.rowInfo.rowData;
    //     this.$nextTick(() => {
    //       this.$refs.addArticleToWarehouseRef.show();
    //     });
    //   }
    // }
  }
}
</script>

<style scoped>
.image-column {
  padding: 15px;
  border: 1px solid #ddd;
  align-items: center;
}

.btn-invisible {
  background-color: transparent;
  padding: 5px;
}
</style>